const adjustMapToFitMarkers = async (userLocation, searchTerm) => {
    if (!findExerciseLocationMap.map) {
        await initializeMap(userLocation, 10);
    }

    const markers = findExerciseLocationMap.markers;

    const normalizedSearchTerm = searchTerm?.toLowerCase() || "";

    const markerList = Array.from(markers).map((el) => {
        const { lat, lng, city, facility, conveniences, workouttypes } = el.children[0].dataset;

        const parsedConveniences = JSON.parse(conveniences || "[]");
        const parsedWorkoutTypes = JSON.parse(workouttypes || "[]");

        const distance = utils["google-maps"].calculateDistance(
            userLocation.lat,
            userLocation.lng,
            parseFloat(lat),
            parseFloat(lng)
        );

        return {
            distance,
            city,
            facility,
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            conveniences: parsedConveniences,
            workouttypes: parsedWorkoutTypes
        };
    });

    const filteredAndSorted = markerList
        .filter(({ city, facility }) => {
            return (
                city?.toLowerCase().includes(normalizedSearchTerm) ||
                facility?.toLowerCase().includes(normalizedSearchTerm)
            );
        })
        .sort((a, b) => a.distance - b.distance);

    // If no matches, fallback to top 3 closest facilities (regardless of search)
    const top3Matches = filteredAndSorted.length > 0
        ? filteredAndSorted.slice(0, 3)
        : markerList.sort((a, b) => a.distance - b.distance).slice(0, 3);

    // Fit the map to the top 3 closest items
    const bounds = new google.maps.LatLngBounds();

    // User location as the center anchor
    const userLatLng = new google.maps.LatLng(userLocation.lat, userLocation.lng);
    bounds.extend(userLatLng);

    top3Matches.forEach(({ lat, lng }) => {
        bounds.extend(new google.maps.LatLng(lat, lng));
    });

    findExerciseLocationMap.map.fitBounds(bounds);

    // Set max zoom (e.g., 10) when bounds are fitted
    const boundsListener = google.maps.event.addListenerOnce(
        findExerciseLocationMap.map,
        "bounds_changed",
        () => {
            if (findExerciseLocationMap.map.getZoom() > 15) {
                findExerciseLocationMap.map.setZoom(15);
            }

            google.maps.event.removeListener(boundsListener);
        }
    );

    // Update internal state
    findExerciseLocationMap.initialMapState.center = findExerciseLocationMap.map.getCenter();
    findExerciseLocationMap.initialMapState.zoom = 10;
}

const adjustMapToFitMarkersUrl = (markers) => {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(marker => {
        const position = marker.position;
        if (position) {
            bounds.extend(position);
        } else {
            console.warn("Marker position is not defined.");
        }
    });

    findExerciseLocationMap.map.fitBounds(bounds);

    const handleBoundsChanged = () => {
        if (findExerciseLocationMap.map.getZoom() > 15) {
            findExerciseLocationMap.map.setZoom(15);
        }
        google.maps.event.removeListener(boundsListener);
    };

    // Set the listener and ensure it's removed after triggering once
    const boundsListener = google.maps.event.addListenerOnce(findExerciseLocationMap.map, 'bounds_changed', handleBoundsChanged);
}

const handleFilterReset = async () => {
    showAllMarkers();

    if (!findExerciseLocationMap.hasResetToInitialState && !findExerciseLocationMap.savedInputValue) {

        const { center, zoom } = findExerciseLocationMap.initialMapState;
        if (center && zoom) {
            initializeMap(center, zoom);
        }
        findExerciseLocationMap.hasResetToInitialState = true;
        //If user has searched for something find this instead
    } else if (findExerciseLocationMap.savedInputValue) {
        await findGeoCodingResults(findExerciseLocationMap.savedInputValue);
    }

    // URL parameters found, reset the flag to allow future resets if needed
    findExerciseLocationMap.hasResetToInitialState = false;
};
